(function () {
  'use strict';

  angular.module('eclipseApp.checkout')

    .controller('techInstallCtrl', ['$scope', 'fulfillmentOptions', 'buyService', function ($scope, fulfillmentOptions, buyService) {

      $scope.fulfillment.loading = true;

      buyService.setStepTouched();

      buyService.getTechInstallViewMessage()
        .then(function (resp) {
          $scope.techInstallMessage = resp.replace('[age]', buyService.getAgeOfMajority());
        });

      //console.log('@techInstallCtrl:BEFORE ($scope) ', $scope);
      $scope.$on('$viewContentLoaded', function () {

        $scope.$parent.resetScope();
        // reset checkbox when switching from one tab to another`
        $scope.fulfillment.agree = false;
        console.log('@techInstallCtrl:VIEWCONTENTLOADED: ($scope) ', $scope);
      });

    }]);

})();
